/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {NudeShellLayoutComponent} from './nude-shell-layout.component';
import {UpdateAdvertiserPageComponent} from './update-advertiser-page.component';
import {ReleaseNotesPageComponent} from './release-notes-page.component';
import {DummyPageComponent} from './dummy-page.component';
import {AdnDocsPageComponent} from './adn-docs-page.component';
import {AdTagGeneratorPageComponent} from '../../ad-tag/ad-tag-generator-page.component';
import {McpAuthorizePageComponent} from '../../admin/api-key/mcp-authorize-page.component';
import {OAUTH_CONSENT_PARAMS} from '../../admin/api-key/api-key-commons';

export function nudeStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider
          .state('nude', {
            abstract: true,
            component: NudeShellLayoutComponent
          })
          .state('nude.advertiser', {
            url: '/advertiser/?id&context&auth_token',
            views: {
              'content@nude': {
                component: UpdateAdvertiserPageComponent
              }
            },
            data: {
              public: true,
              title: 'Update Advertiser'
            }
          })
          .state('nude.release-notes', {
            url: '/release-notes',
            views: {
              'content@nude': {
                component: ReleaseNotesPageComponent
              }
            },
            data: {
              public: true,
              title: 'Release Notes'
            }
          })
          .state('nude.release-notes.release-note', {
            url: '/release-note/:urlSlug',
            views: {
              'content@nude': {
                component: ReleaseNotesPageComponent
              }
            },
            data: {
              public: true,
              title: 'Release Notes'
            }
          })
          .state('nude.dummy', {
            url: '/dummy',
            views: {
              'content@nude': {
                component: DummyPageComponent
              }
            },
            data: {
              public: true,
              title: 'Dummy Page for Demonstration Purposes'
            }
          })
          .state('nude.adn', {
            url: '/adn',
            views: {
              'content@nude': {
                component: AdnDocsPageComponent
              },
              'title@nude': stateTitleView()
            },
            data: {
              public: true,
              title: 'Documentation for adn.js'
            }
          })
          .state('nude.tag', {
            url: '/tag?auId&auW&auH&design&auName',
            reloadOnSearch: false,
            views: {
              'content@nude': {
                component: AdTagGeneratorPageComponent
              },
              'title@nude': stateTitleView()
            },
            data: {
              public: true,
              title: 'Ad Tag Generator and Tester'
            }
          })
          .state('nude.mcp-authorize', {
            url: '/authorize?app&callback&code_challenge&code_challenge_method&redirect_uri&state&client_id&resource',
            params: {...OAUTH_CONSENT_PARAMS},
            views: {
              'content@nude': {
                component: McpAuthorizePageComponent
              }
            },
            data: {
              title: 'Authorise'
            }
          });
  }, adnRouterHelper);
}
